var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "relative flex items-center flex-shrink-0 rounded-full",
      class: {
        "h-7": !_vm.dense,
        "h-6": _vm.dense
      },
      style: {
        backgroundColor: _vm.currentChip.backgroundColor,
        padding: "0rem 0.5rem"
      },
      attrs: { "data-id": _vm.id, title: _vm.currentChip.label }
    },
    [
      _c("BlTextBody3", {
        staticClass: "truncate",
        class: {
          "text-sm": !_vm.dense,
          "text-xs": _vm.dense
        },
        style: { color: _vm.currentChip.color },
        attrs: { "data-id": _vm.id, text: _vm.currentChip.label }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63f0bae6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63f0bae6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlChip.vue
// module id = null
// module chunks = 